// @ts-nocheck
import '../../sass/pages/_home.scss'

// IMPORT COMPONENTS
import "../components/homeSwipers";
import SplitText from "../components/splitText";

// IMPORT HELPERS
import { pageLoaded } from "../utils/helpers";

declare var $clamp: any;
declare var gsap: any;
declare var ScrollTrigger: any;
gsap.registerPlugin(ScrollTrigger);

declare global {
  interface Window {
    drupalSettings: any,
    dataLayer: any;
  }
}

const startTrigger = { start: 'top bottom-=50px' }
const defaultTransition = (translate: { [t: string]: number }) => {
  return { opacity: 0, ...translate }
}

// Initialize
init()
shortText()

function init() {
  let mainTitle = new SplitText('.mxbudqtr-banner__title, .mxbudqtr-explore__title', { auto: false });
  new SplitText('.mxbudqtr-shop__title, .mxbudqtr-experience__title, .mxbudqtr-social-network__title, .mxbudqtr-shop-card__title')

  // Fix Card Text
  let textCards = document.querySelectorAll('.mxbudqtr-content-info__desc')
  for (let i = 0; i < textCards.length; i++) {
    const element = textCards[i];
    if (typeof $clamp != 'undefined') $clamp(element, { clamp: 'auto' });
  }

  let sections = setInitialState()

  pageLoaded(() => {
    mainTitle.triggerAnimation()
    animate(sections)
  })
}

function setInitialState(): any {
  // Banner
  let bTexts = gsap.set('.mxbudqtr-banner__featured, .mxbudqtr-banner__desc', { ...defaultTransition({ translateX: -30 }) })
  let bImage = gsap.set('.mxbudqtr-banner__image', { opacity: 0 })
  let bBtn = gsap.set('.mxbudqtr-banner__btn', { ...defaultTransition({ translateY: 30 }) })

  // Explore Cards
  gsap.set('.mxbudqtr-content-info', { ...defaultTransition({ translateY: -30 }) })

  // Shop Section
  let sImage = gsap.set('.mxbudqtr-shop-card__image', { ...defaultTransition({ translateX: -30 }) })
  let sDescAndBtn = gsap.set('.mxbudqtr-shop-card__desc, .mxbudqtr-shop-card__btn', { ...defaultTransition({ translateY: 30 }) })
  let sfinalText = gsap.set('.mxbudqtr-shop__desc', { ...defaultTransition({ translateY: 30 }) })
  let sBtns = gsap.set('.mxbudqtr-shop__btn', { opacity: 0, translateY: 30 })

  // Last Card Swiper
  // let swipers = gsap.set('.mxbudqtr-experience-card, .mxbudqtr-network-card', { ...defaultTransition({ translateX: 30 }) })
  let swipers = gsap.set('.mxbudqtr-network-card', { ...defaultTransition({ translateX: 30 }) })

  // Description Network
  let networkDesc = gsap.set('.mxbudqtr-social-network__desc', { ...defaultTransition({ translateY: 30 }) })

  return {
    banner: { bTexts, bImage, bBtn },
    shop: { sImage, sDescAndBtn, sfinalText, sBtns },
    swipers, networkDesc
  }
}

function animate(sections: any) {
  animateBannerSection(sections.banner)
  animateShopSection(sections.shop)
  animateSwipers()
  animateSingleElements(sections.networkDesc)
}

// Animate Banner Section
function animateBannerSection({ bTexts, bImage, bBtn }: any) {
  const tl = gsap.timeline({ ease: 'power1.in', delay: .8 });
  let mm = gsap.matchMedia();

  mm.add("(max-width: 767px)", () => {
    tl.to(bTexts.targets(), { duration: 0.8, opacity: 1, translateX: 0, stagger: 0.2 }, 'mainTitle')
    tl.to(bImage.targets(), { duration: 0.8, opacity: 1, ease: 'power1.in' }, 'mainTitle+=0.1')
    tl.to(bBtn.targets(), { duration: 0.8, opacity: 1, translateY: 0 }, 'mainTitle+=0.7')
  })
  mm.add("(min-width: 768px)", () => {
    tl.to(bTexts.targets(), { duration: 0.8, opacity: 1, translateX: 0, stagger: 0.2 }, 'mainTitle')
    tl.to(bBtn.targets(), { duration: 0.8, opacity: 1, translateY: 0 }, 'mainTitle+=0.6')
    tl.to(bImage.targets(), { duration: 0.8, opacity: 1, ease: 'power1.in' }, 'mainTitle+=0.7')
  })
}

// Animate Cards
function animateSingleElements(networkDesc: any) {
  ScrollTrigger.batch(".mxbudqtr-content-info", {
    ...startTrigger,
    onEnter: (batch: any) => gsap.to(batch, { duration: 0.8, opacity: 1, translateY: 0, stagger: 0.2, ease: 'power2.out' }),
  });

  gsap.to(networkDesc.targets(), {
    duration: 0.8, opacity: 1, translateY: 0,
    scrollTrigger: { trigger: networkDesc.targets(), ...startTrigger }
  })
}

// Animate Shop
function animateShopSection({ sImage, sDescAndBtn, sfinalText, sBtns }: any) {
  let mm = gsap.matchMedia();

  mm.add("(max-width: 767px)", () => {
    gsap.to(sImage.targets(), {
      duration: .8, opacity: 1, translateX: 0, ease: 'power1.out',
      scrollTrigger: { trigger: sImage.targets(), ...startTrigger }
    })
    gsap.to(sDescAndBtn.targets(), {
      duration: .8, opacity: 1, translateY: 0, stagger: .3,
      scrollTrigger: { trigger: sDescAndBtn.targets(), ...startTrigger }
    })
  })

  mm.add("(min-width: 768px)", () => {
    ScrollTrigger.batch(sImage.targets(), {
      start: 'top bottom-=100px',
      onEnter: (batch: any) => gsap.to(batch, { duration: 0.8, opacity: 1, translateX: 0, stagger: 0.3, ease: 'power2.out' }),
    });

    sDescAndBtn.targets().forEach((elm: any) => {
      gsap.to(elm, {
        duration: .8, opacity: 1, translateY: 0, stagger: .3,
        scrollTrigger: { trigger: elm, ...startTrigger }
      })
    })
  })

  gsap.to(sfinalText.targets(), {
    duration: .8, opacity: 1, translateY: 0,
    scrollTrigger: { trigger: sfinalText.targets(), ...startTrigger }
  })

  sBtns.targets().forEach((btn: any) => {
    gsap.to(btn, {
      duration: .8, opacity: 1, translateY: 0,
      onComplete: (e: any) => {
        btn.classList.add('mxbudqtr-shop__btn--loaded')
        gsap.set(btn, { clearProps: "transform" })
      },
      scrollTrigger: { trigger: btn, ...startTrigger }
    })
  })
}

// Animate Swipers
function animateSwipers() {
  // gsap.to('.mxbudqtr-experience-card', {
  //   duration: .8, opacity: 1, stagger: .3, translateX: 0,
  //   scrollTrigger: { trigger: '#experienceSwiper', ...startTrigger }
  // })
  gsap.to('.mxbudqtr-network-card', {
    duration: .8, opacity: 1, stagger: .3, translateX: 0,
    scrollTrigger: { trigger: '#socialSwiper', ...startTrigger }
  })
}

function shortText(){
  const textCards = document.querySelectorAll(".mxbudqtr-explore .mxbudqtr-contents .mxbudqtr-contents__item .mxbudqtr-content-info__desc")
  if (textCards) {
    textCards.forEach(currentText =>{
      const text = currentText.textContent
      const shortText = window.innerWidth < 767 
      ? text.length > 86 ? text.slice(0, 86) + '...' : text
      : text.length > 388 ? text.slice(0, 388) + '...' : text
      currentText.innerText = shortText
    })
  }
}

setTimeout(() => {
  //dataLayer boton slider section shop
  const btnSlideBeers = document.querySelectorAll(".mxbudqtr-shop .mxbudqtr-shop-card__btn")
  if (btnSlideBeers) {
    btnSlideBeers.forEach(btn => {
      btn.addEventListener("click", (e) => {
        // e.preventDefault();
        const thisParentElement = e.target.parentElement
        if (thisParentElement) const productName = thisParentElement.querySelector(".mxbudqtr-shop-card__title").textContent
        if(productName){
          window.dataLayer.push({
            'event': 'GAEvent',​
            'event_category': 'Content',​
            'event_action': 'Content', ​
            'event_label':  'Comprar_en_TaDa',
            'interaction':'true',​
            'component_name': 'Comprar_en_TaDa-Nuestras-Cervezas', 
            'element_text':  'Link_out',  
            'product': productName, // Dinámico: Budweiser botella, Budweiser Catar 2022, Budweiser nitro gold
          
          });
          
          // console.log('ultimo')
        }
        // if(btn.href) location.href = btn.href
      })
    })
  }
}, 1000)


//dataLayer boton slider section explore
let btnCards = document.querySelectorAll(".mxbudqtr-explore .mxbudqtr-content-info__back .mxbudqtr-content-info__btn") as any;
if (btnCards) {
  btnCards.forEach((btn) => {
    btn.addEventListener("click", (e: any) => {
      e.preventDefault()
      const thisSibilingElement = e.target.parentElement.previousElementSibling
      if(thisSibilingElement) const elementText = thisSibilingElement.querySelector("figcaption .mxbudqtr-content-info__title").textContent
      if(elementText){
        window.dataLayer.push({ 
          'event': 'GAEvent',
          'event_category': 'Content',
          'event_action': 'Content', 
          'event_label': `${elementText}`, // Dinámico: Home, Nuestra Cerveza, Campañas, Experiencias, Qatar2022, FAQs,
          'interaction':'true', 
          'component_name':'Contenido del home',
          'element_text': `${elementText}`, // Dinámico: Home, Nuestra Cerveza, Campañas, Experiencias, Qatar2022, FAQs,      
        });
      }
      if(btn.href) location.href = btn.href
    });
  });
}

//dataLayer boton principal header
const btnMainHeader = document.querySelector(".mxbudqtr-banner .mxbudqtr-banner__btn")
if(btnMainHeader){
  btnMainHeader.addEventListener("click", (e)=>{
    e.preventDefault()
    window.dataLayer.push({ 
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Content', 
      'event_label': 'Participa-Home',
      'component_name':'Sección-Home',
      'element_text': 'Mundial-Qatar-2022',
    });
    if(btnMainHeader.href) location.href = btnMainHeader.href
  })
}